
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AppServiceService } from 'src/app/app-service.service';
import Swal from 'sweetalert2';
declare var kendo;
declare var $;

@Component({
  selector: 'app-signin-log',
  templateUrl: './signin-log.component.html',
  styleUrls: ['./signin-log.component.scss']
})

export class SigninLogComponent implements OnInit {
  public appSetting;
  public urlPreDay;
  public urlSysId;
  public urlSysIdd;
  public NLS;
  public U_Name;
  public U_DOB;
  public U_Comments;
  public updateTime;
  public lastEntryTime;
  public lastUpdateTime;
  public patientInfoData;
  public weekDayList;
  public IsEdit;
  public IsUpdated;
  public editedPatientId;
  public editedPatientIdCopy;
  public selectedDay;
  public totalCount = 0;
  public remainingDays;
  public IsMore = 0;
  public secondsInterval = null;
  public minutesInterval = null;
  public changePassword: FormGroup;
  public submitted = false;
  public patientType = '';
  public strikethrough = 0 ;
  public insertResponse;
  public loading = false;
  public DBName;
  public ClientId;
  public dbJson;
  public dbJsonn;
  public clinicList;

  public specialElementHandlers = {
    '.no-export': function (element, renderer) {
      return true;
    }
  };

  constructor(public router: Router, public formBuilder: FormBuilder, public appService: AppServiceService) { }

  ngOnInit() {
    this.changePassword = this.formBuilder.group({
      oldPassword: ['', [Validators.required, Validators.minLength(8), passwordStrong]],
      password: ['', [Validators.required, Validators.minLength(8), passwordStrong]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8), passwordStrong]]
    });

    const ths = this;
    this.IsEdit = 0;
    this.IsUpdated = 0;
    this.appService.getAdminURL();

    const jsonData = this.appService.decryptData(localStorage.getItem('AdminDetails'));
    //const jsonData = localStorage.getItem('AdminDetails1');

    this.appSetting = JSON.parse(jsonData);
    this.clinicList = this.appSetting.resultClinic;
   

    this.DBName = this.appSetting.DbName;
    this.ClientId = this.appSetting.ClientId;

    this.urlPreDay = this.appService.apiUrl + '?action=GET&prevDays';
    this.urlSysId = this.appService.apiUrl + '?action=GET&SysId=1';
    this.urlSysIdd = this.appService.serviceURL + 'CheckStatus';

    const expiryDate = this.appSetting.ExpiryDate;
    const business_id = this.appSetting.Email_id;
    const LicenseType = this.appSetting.LicenseType;
    console.log(LicenseType);
    this.remainingDays = this.calculateDate(expiryDate);

    if (this.remainingDays <= 10) {
      if (localStorage.getItem('alertRemove') != '1') {
      
          this.showWarningDialog(this.remainingDays,business_id,LicenseType);
      }
    }
    
    //alert(this.clinicList);
    if (this.remainingDays > 0) {
        this.appService.getData(this.urlPreDay).subscribe(data => {
          this.weekDayList = data;
        });

        this.selectedDay = new Date().getDay();

        this.dbJson = {
          dbName:this.DBName
        };

        this.loading = false;
        const url = this.appService.apiUrl + '?action=GET&day=' + this.selectedDay;       
        this.appService.postData(url, JSON.stringify(this.dbJson)).subscribe(data => {
          this.patientInfoData = data;
          this.loading = false;
        });
        this.appSetting = JSON.parse(jsonData);
          console.log(this.appSetting.ClientId);
          this.dbJsonn = {
            ClientId:this.appSetting.ClientId,

          };

        this.secondsInterval = setInterval(function () {
          if (ths.IsEdit == 0) {           
            ths.appService.postData(ths.urlSysId, JSON.stringify(ths.dbJson)).subscribe(data => {
              if (ths.lastEntryTime != data[0].entryDateTime || ths.lastUpdateTime != data[0].updateDateTime) {
                ths.lastEntryTime = data[0].entryDateTime;
                ths.lastUpdateTime = data[0].updateDateTime;

                const url = ths.appService.apiUrl + '?action=GET&day=' + ths.selectedDay;
                ths.appService.postData(url, JSON.stringify(ths.dbJson)).subscribe(data => {
                  ths.patientInfoData = data;
                  ths.getTotal(data);               
                });
              }
            });
          }
        }, 1000);

        this.minutesInterval = setInterval(function () {
          if (ths.IsEdit == 0) {
              const url = ths.appService.apiUrl + '?action=GET&day=' + ths.selectedDay;
              ths.appService.postData(url, JSON.stringify(ths.dbJson)).subscribe(data => {
                ths.patientInfoData = data;
                ths.getTotal(data);
              });
          }
        }, 60000);
      }
  }

  calculateDate(date2) {
    const startDate = new Date();
    const expiryDate = new Date(date2);
    const diffc = expiryDate.getTime() - startDate.getTime();
    const days = Math.round(diffc / (1000 * 60 * 60 * 24));

    return days;
  }
  showWarningDialog(days,business_id,LicenseType) {
    let strMesg;

    if (days > 0) {
      strMesg = 'Your Subscription for this Clinic is set to expire within ' + days + ' days.Please reach out to your Business Administrator('+ business_id +') to renew your subscription. <br /> Thank you';
    } else if (days == 0) {
      strMesg = 'Your Subscription period will expire today. Please reach out to your Business Administrator('+ business_id +') to renew your subscription. <br /> Thank you';
    } else if (days < 0) {
      strMesg = 'The '+LicenseType+' period has expired. Please reach out to your Business Admin('+ business_id +') to renew the license. <br /> Thank you';
    }
 
    Swal.fire({
      title: '',
      html: strMesg,
      type: 'warning',
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      // confirmButtonText: 'Renew Licence'

    }).then((result) => {
      if (result.value) {
        localStorage.setItem('alertRemove', '1');
        //this.RenewLicence();
      }else{
        if(days <= 0){
          this.logOut();
        }
      }
    });
  }

  updatePatientData(Id, p_updateDate,IsDelete) {
    const ths = this;
    ths.appService.postData(ths.urlSysIdd, ths.dbJsonn).subscribe(data => {
      if (data.status === 0) {
        alert("Your Clinic is deactivated, Please contact your CSA to activate.");

        localStorage.removeItem('LogInDetails');
        localStorage.removeItem('AdminDetails');
        window.location.reload(); 
        
      }else{
    const d = new Date();
    let sDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();

    const sNLS = $('#updateNLS_' + Id).val();
    const nlsText = sNLS.length;

    if (nlsText > 0 && IsDelete == 0) {
      $('#save_' + Id).prop('disabled', false);
      $('#save_' + Id).css('opacity', '1');
    } else {
      $('#save_' + Id).prop('disabled', true);
      $('#save_' + Id).css('opacity', '0.3');
    }

    const disabled = $('#save_' + Id).prop('disabled');
    const UName = this.appService.encryptData($('#updateName_' + Id).val());
    const UDOB = this.appService.encryptData($('#updateDOB_' + Id).val());

    const tempJson = {
      dbName:this.DBName,
      nLS: $('#updateNLS_' + Id).val(),
      U_Name: UName.toString(),
      U_DOB: UDOB.toString(),
      nLS_Edit: $('#updateNLS_' + Id).val(),
      U_Name_Edit: UName.toString(),
      U_DOB_Edit: UDOB.toString(),
      UpdateComment: $('#updateComments_' + Id).val(),
      type: $('#updateType_' + Id).val(),
      updateTime: sDate
    };

    if (!disabled) {
      if (sNLS != null && sNLS.length > 0) {
        $('#save_' + Id).prop('disabled', true);
        $('#save_' + Id).css('opacity', '0.3');

        const url = this.appService.apiUrl + '?action=UPDATE&Id=' + Id;
        this.appService.postData(url, JSON.stringify(tempJson)).subscribe(data => {
          if (data == 'OK') {
            this.insertResponse = data;
            this.IsUpdated = 1;            
            this.bindDataInTD(tempJson);  
            this.IsEdit = 0;
          }
        });
      } else {
        this.IsEdit = 0;
      }
    }
  }
});
}

  bindDataInTD(data) {
    setTimeout(() => {
      $('#bindName_' + this.editedPatientId).text(this.decryptDetails(data.U_Name));
      $('#bindDOB_' + this.editedPatientId).text(this.decryptDetails(data.U_DOB));
      $('#bindComments_' + this.editedPatientId).text(data.UpdateComment);
      $('#bindNLS_' + this.editedPatientId).text(data.nLS).css({'text-transform': 'uppercase'});

      if (data.type === '2') {
        $('#bindType_' + this.editedPatientId).text('');
        this.editedPatientIdCopy = '';
      }
    }, 2);
  }

  deleteRecord(Id, NLS, isDelete) {
    const ths = this;
    ths.appService.postData(ths.urlSysIdd, ths.dbJsonn).subscribe(data => {
      if (data.status === 0) {
        alert("Your Clinic is deactivated, Please contact your CSA to activate.");

        localStorage.removeItem('LogInDetails');
        localStorage.removeItem('AdminDetails');
        window.location.reload(); 
        
      }else{
    const nlsText = NLS.length;
    let IsUpdate = 0;

    if (nlsText > 0) {
      IsUpdate = 1; 
    } else {
      IsUpdate = 0;
    }

    const d = new Date();
    const sDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();

    if (isDelete == 0) {
      isDelete = 1;

      Swal.fire({
        title: 'Do you want to delete this record ?',
        type: 'warning',
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'

      }).then((result) => {
        if (result.value) {
          const tempJson = {
            dbName: this.DBName,
            isDelete: isDelete,
            isUpdated: IsUpdate,
            updateTime: sDate
          };

          const url = this.appService.apiUrl + '?action=DELETE&Id=' + Id;
          this.appService.postData(url, JSON.stringify(tempJson)).subscribe(data => {
            if (data == 'OK') {
              this.IsUpdated = 1;
              this.strikethrough = 1;    
              $('.strikethrough_' + this.editedPatientId).addClass('strikethrough');              
              this.IsEdit = 0;
            }
          });
        } 
      });

    } else if (isDelete == 1) {
      isDelete = 0;

      const tempJson = {
        dbName: this.DBName,
        isDelete: isDelete,
        isUpdated: IsUpdate,
        updateTime: sDate
      };

      const url = this.appService.apiUrl + '?action=DELETE&Id=' + Id;
      this.appService.postData(url, JSON.stringify(tempJson)).subscribe(data => {
        if (data == 'OK') {
          if (nlsText == 0) {
            this.IsUpdated = 0;
          } else{
            this.IsUpdated = 1;
          }
          
          $('.strikethrough_' + this.editedPatientId).removeClass('strikethrough');         
          this.IsEdit = 0;
        }
      });
    }
  }
});
}

  filterPatient(day) {
    this.selectedDay = day;
    const todayDay = new Date().getDay();
    this.loading = true;
    const url = this.appService.apiUrl + '?action=GET&day=' + this.selectedDay;

    this.appService.postData(url, JSON.stringify(this.dbJson)).subscribe(data => {
      if (data != 'No Data found!'){
        if (this.selectedDay != todayDay) {
          this.IsEdit = -1;
        } else {
          this.IsEdit = 0;
        }
        this.patientInfoData = data;
        this.getTotal(data);
        this.loading = false;
      }
    });
  }

  filterClinic(clinic) {
    const postJson = {
      clinic_id: clinic,
    };

    const url = this.appService.serviceURL + 'ClinicList';
      this.loading = true;
      this.appService.postData(url, postJson).subscribe(data => {
        if (data.status === 0) {
          $('#error_msg').show();
          this.loading = false;

        }else{

          
          console.log(data);
          const adminDetails = this.appService.encryptData(data);
          //window.location.href = this.appService.apiCsaUrl + data.ClientId;
          localStorage.removeItem('AdminDetails');
          localStorage.setItem('AdminDetails', adminDetails);
          window.location.reload();
          this.loading = false;
       }
      });
  }

  showEditView(patientInfo) {    
    this.IsUpdated = "";
    this.IsEdit = 1;
    this.editedPatientId = patientInfo.Id;
    this.editedPatientIdCopy = patientInfo.Id;
  }

  cancelEditView() {
    this.IsEdit = 0;
    const url = this.appService.apiUrl + '?action=GET&day=' + this.selectedDay;
    this.appService.postData(url, JSON.stringify(this.dbJson)).subscribe(data => {
      this.patientInfoData = data;
    });
  }

  dateMasking(Id) {
    $('#updateDOB_' + Id).inputmask({ alias: 'mm/dd/yyyy', placeholder: 'MM/DD/YYYY' });
  }

  enableSaveButton(Id, isDelete) {
    const nlsText = $('#updateNLS_' + Id).val().length;

    if (nlsText > 0 && isDelete == 0) {
      $('#save_' + Id).prop('disabled', false);
      $('#save_' + Id).css('opacity', '1');
      $('#save_' + Id).css('cursor', 'pointer');
      $('#delete_' + Id).prop('disabled', false);
      $('#delete_' + Id).css('opacity', '1');
      $('#delete_' + Id).css('cursor', 'pointer');
      
    } else {
      $('#save_' + Id).prop('disabled', true);
      $('#save_' + Id).css('opacity', '0.3');
      $('#save_' + Id).css('cursor', 'not-allowed');
      $('#delete_' + Id).prop('disabled', true);
      $('#delete_' + Id).css('opacity', '0.3');
      $('#delete_' + Id).css('cursor', 'not-allowed');
      
      
    }
    if (nlsText > 0 && isDelete == 1) {
      $('#remove_' + Id).prop('disabled', false);
      $('#remove_' + Id).css('opacity', '1');
      $('#remove_' + Id).css('cursor', 'pointer');
      

    }else{
      $('#remove_' + Id).prop('disabled', true);
      $('#remove_' + Id).css('opacity', '0.3');
      $('#remove_' + Id).css('cursor', 'not-allowed');
      

    }
  }

  getTotal(data) {
    this.totalCount = 0;

    for (let i = 0; i < data.length; i++) {
      if (data[i].isDelete == 0) {
        this.totalCount = this.totalCount + 1;
      }
    }

    $('#totalCount').html(this.totalCount);
  }

  decryptDetails(data) {
    var decData = this.appService.decryptData(data);
    var strdata = decData.substring(1, decData.length - 1);
    return strdata;
  }

  exportToPdf() {
   const ths =this;
    ths.appService.postData(ths.urlSysIdd, ths.dbJsonn).subscribe(data => {
      if (data.status === 0) {
        localStorage.removeItem('LogInDetails');
        localStorage.removeItem('AdminDetails');
        window.location.reload(); 
        
      }else{
        $('.last-td').hide();
        const clinic_name = this.appSetting.clinic_name;
        const date = this.patientInfoData[0].entryDate;
        $('.logdate').html(date);
    
        kendo.drawing.drawDOM('#dataTabel', 
          {
            allPages: true,
            avoidLinks: true, 
            paperSize: 'A4',
            margin: { top: '2cm', bottom: '1cm', left: '1cm', right: '1cm' },
            scale: 0.5,
            repeatHeaders: true,
            template: $('#page-template').html()
    
          }).then(function (group) {
            kendo.drawing.pdf.saveAs(group, clinic_name+'' + date + '.pdf');
            $('.last-td').show();
          });
      }
    });
    
  }

  showMore() {
    if (this.IsMore === 0) {
      this.IsMore = 1;
      $('.up-container').css('bottom', '80px');
      $('.up-container').css('transition', '1s');
      $('#icon-up-down').removeClass('fa-angle-double-up');
      $('#icon-up-down').addClass('fa-angle-double-down');

    } else {
      this.IsMore = 0;
      $('.up-container').css('bottom', '0px');
      $('.up-container').css('transition', '1s');
      $('#icon-up-down').removeClass('fa-angle-double-down');
      $('#icon-up-down').addClass('fa-angle-double-up');
    }

    if (this.IsMore == 1) {
      setTimeout(() => {
        this.IsMore = 0;
        $('.up-container').css('bottom', '0px');
        $('.up-container').css('transition', '1s');
        $('#icon-up-down').removeClass('fa-angle-double-down');
        $('#icon-up-down').addClass('fa-angle-double-up');
      }, 5000);
    }
  }

  onChangePassword(formValues) {
    this.submitted = true;
    if (this.changePassword.invalid) {
      return;
    }
    if (($('#password').val() !== ($('#cnfrmPswrd').val()))) {
      Swal.fire('', 'New password does not match.', 'warning');
      return;
    }

    const postJson = {
      EmailId: this.appSetting.EmailId,
      Password: formValues.password,
      Old_Password: formValues.oldPassword
    };
    const url = this.appService.serviceURL + 'ChangeClientPassword';
    this.appService.postData(url, postJson).subscribe(data => {
      if (data.Status === '1') {
        Swal.fire('', data.Message, 'success').then((result) => {
          $('#passwordModal').modal('toggle');
          this.clearData();
          this.logOut();
        });
      } else {
        Swal.fire('', data.Message , 'info');
      }
    });
  }

  clearData() {
    this.submitted = false;
    $('#oldPassword').val('');
    $('#password').val('');
    $('#cnfrmPswrd').val('');
  } 

  logOut() {
    clearInterval(this.secondsInterval);
    clearInterval(this.minutesInterval);
    localStorage.removeItem('AdminDetails');
    localStorage.removeItem('alertRemove');
    this.router.navigateByUrl('/Admin/Login');
  }

  RenewLicence(){
    this.logOut();
    window.open('http://64.94.164.16/Anchor-Software-Solution/renew/client_detail/'+this.ClientId , '_blank');
  }
}

export function passwordStrong(control: FormControl): { [key: string]: any } {
  const hasSpecialChar = /[!@#$%^&*(),.?':{}|<>]/.test(control.value);
  const hasNumber = /\d/.test(control.value);
  const hasAlphabet = /[A-Z a-z]/.test(control.value);
  const passwordlength = control.value.length;
  const valid = hasSpecialChar && hasNumber && hasAlphabet && passwordlength >= 8;
  if (!valid) {
    return { strong: true };
  }
  return null;
}
